<template>
  <div class="model-videos__slider-plate">
    <div class="img-wrapper">
      <nuxt-img
        loading="lazy"
        :src="`https://i.ytimg.com/vi/${video.id}/maxresdefault.jpg`"
        alt="video"
        :draggable="false"
      />
    </div>
    <div class="title-wrapper">
      <div class="model-videos__slider-title">
        {{ video.name }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ModelVideo } from '~/interfaces/api';

defineProps({
  video: {
    type: Object as () => ModelVideo,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.model-videos__slider-plate {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 296px;
  //min-height: 168px;
  .img-wrapper {
    display: flex;
    margin: 0 auto;
    flex-grow: 1;
    cursor: pointer;
    width: 100%;
    height: 162px;
    img {
      flex-grow: 1;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 4px;
    }
  }
  .title-wrapper {
    cursor: pointer;
    width: 100%;
    margin-top: 16px;
  }
  @include md-block {
    width: 296px;
    .img-wrapper {
      height: 168px;
    }
  }
  @include lg-block {
    width: 301px;
    .img-wrapper {
      height: 171px;
    }
  }
  @include xl-block {
    width: 285px;
    .img-wrapper {
      height: 162px;
    }
  }

  @include xxl-block {
    width: 365px;
    .img-wrapper {
      height: 206px;
    }
  }
}

.model-videos__slider-title {
  text-align: left;
  height: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  @include lg-block {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
